<template>
  <img :src="require(`../../images/${srcFileName}`)" :class="sizeClass">
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'xs'
    },
    /* We're supporting icons from images in ../../images, because it does not work to make the
       entire path of the image dynamic.
       See: https://stackoverflow.com/questions/57349167/vue-js-dynamic-image-src-with-webpack-require-not-working */
    srcFileName: {
      type: String,
      required: true
    }
  },
  computed: {
    sizeClass() {
      switch (this.size) {
      case 'xs':
      case 'sm':
      case 'lg':
        return `icon-${this.size}`
      default:
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-xs {
  width: 10px;
  height: 10px;
}

.icon-sm {
  width: 15px;
  height: 15px;
}

.icon-lg {
  width: 30px;
  height: 30px;
}
</style>
